import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { Physicals } from '../../canvas/entities/Physicals';
import { Counter } from './Counter';

export const createCounter = defineCommand(
    'createCounter',
    'Counter: Create...',
    (cc) => {
        Physicals.createAtCameraPosition(cc, Counter, x => {
            // x.url = 'https://www.youtube.com/watch?v=7wtfhZwyrcc';
        });
    }
);

export const counterIncrement = defineCommand(
    'counterIncrement',
    'Counter: Increment',
    (cc, [targetId]: [string]) => {

        const objects = cc.resolve(ObjectManager);

        const subject = resolveSubject(cc, targetId)?.as(Counter);
        if (!subject) return;

        objects.update(() => {
            subject.value++;
        });
    },
);

export const counterDecrement = defineCommand(
    'counterDecrement',
    'Counter: Decrement',
    (cc, [targetId]: [string]) => {

        const objects = cc.resolve(ObjectManager);

        const subject = resolveSubject(cc, targetId)?.as(Counter);
        if (!subject) return;

        objects.update(() => {
            subject.value--;
        });
    },
);

export const counterSet = defineCommand(
    'counterReset',
    'Reset: Set',
    (cc, [targetId, value]: [string, string | number]) => {

        const objects = cc.resolve(ObjectManager);

        const subject = resolveSubject(cc, targetId)?.as(Counter);
        if (!subject) return;

        objects.update(() => {
            subject.value = parseInt(`${value}`) || 0;
        });
    },
);

export const inCounterCommands = () => inCommands(
    createCounter,
    counterIncrement,
    counterDecrement,
    counterSet,
);

